import { GetterTree, MutationTree, ActionTree } from "vuex";
// firebase
import { Firebase } from "@/config/firebase";
// helpers
import { env } from "@/helpers/env";
//tipos
import { State } from "@/typings/store/index";
import {
  Archivo,
  BlobArchivo,
  DataURLArchivo,
  StateArchivos,
} from "@/typings/store/plugins/easyFirestore/archivos";
import { Empresa } from "@/typings/store/plugins/easyFirestore/empresas";

const refBase = `${env}/v1/empresas`;

const state: StateArchivos = {
  all: {},
};

const getters: GetterTree<StateArchivos, State> = {
  get(_state) {
    return _state.all;
  },
  getArray(_state) {
    return Object.values(_state.all);
  },
};

const mutations: MutationTree<StateArchivos> = {};

const actions: ActionTree<StateArchivos, State> = {
  async setBlob(ctx, data: BlobArchivo): Promise<string> {
    if (!data.file) {
      return "";
    }
    const empresa = ctx.rootGetters["usuario/getEmpresa"] as Empresa;
    const idEmpresa = empresa.id ?? empresa.rut ?? "11111111-1";
    const ref = `${refBase}/${idEmpresa}/${data.ref}`.replaceAll("//", "/");
    const storage = Firebase.storage();
    const storageRef = storage.ref();
    const imagenRef = storageRef.child(ref);
    await imagenRef
      .put(data.file)
      .then()
      .catch((err) => {
        console.log(err);
      });
    const url = await imagenRef.getDownloadURL().catch((err) => {
      console.log(err);
      return "";
    });
    const doc: Archivo = {
      ref: data.ref,
      nombre: data.nombre,
      url: url,
      fecha: data.fecha ?? new Date().toISOString(),
    };
    return ctx.dispatch("set", doc);
  },
  async setDataURL(ctx, data: DataURLArchivo): Promise<string> {
    if (!data.file) {
      return "";
    }
    const empresa = ctx.rootGetters["usuario/getEmpresa"] as Empresa;
    const idEmpresa = empresa.id ?? empresa.rut ?? "11111111-1";
    const ref = `${refBase}/${idEmpresa}/${data.ref}`.replaceAll("//", "/");
    const storage = Firebase.storage();
    const storageRef = storage.ref();
    const imagenRef = storageRef.child(ref);
    await imagenRef
      .putString(data.file, "data_url")
      .then()
      .catch((err) => {
        console.log(err);
      });
    const url = await imagenRef.getDownloadURL().catch((err) => {
      console.log(err);
      return "";
    });
    const doc: Archivo = {
      ref: data.ref,
      nombre: data.nombre,
      url: url,
      fecha: data.fecha ?? new Date().toISOString(),
    };
    return ctx.dispatch("set", doc);
  },
};

const archivos = {
  firestorePath: `{env}/v1/empresas/{idEmpresa}/archivos`,
  firestoreRefType: "collection",
  moduleName: "archivos",
  statePropName: "all",
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default archivos;
